import createWidgetFactory from 'components-framework/widget/create_widget_factory';
import Model from './model';
import View from './view';

const factory = createWidgetFactory({
    name: 'block_risky_cards',
    viewClass: View,
    modelClass: Model,

    methods: {
        checkRiskyCard(creditCardBinNumber, forceUpdate) {
            this.model.set('creditCardBinNumber', creditCardBinNumber);
            forceUpdate && this.model.trigger('change:creditCardBinNumber');
        },
        scrollToWarningMessage() {
            this.scrollToWarningMessage();
        },
        hideBlockingBinsSuccessMessage() {
            this.hideBlockingBinsSuccessMessage();
        },
    },
});

export default factory;
